import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Portfolio from '../views/Portfolio.vue'
import contact from "@/views/Contact";

function lazyLoad(view){
  return() => import(`@/views/${view}.vue`)
}

const routes = [
  {
    path: '/',
    name: 'home',
    props: true,
    component: HomeView,
    meta: {
      title: "FTM Installatietechniek | Professionele Installaties en Onderhoud"
    }
  },
  {
    path: '/klussen',
    name: 'Galerij',
    props: true,
    component: lazyLoad('Portfolio'),
    meta: {
      title: "Klussen | FTM Installatietechniek"
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    props: true,
    component: contact,
    meta: {
      title: "Contact | FTM Installatietechniek"
    }
  },
  {
    path: '/over-ons',
    name: 'About',
    props: true,
    component: lazyLoad('About'),
    meta: {
      title: "Over ons | FTM Installatietechniek"
    }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  next();
})

export default router
